(function (){
    const API_URL = 'https://api.syrokan.cc/';
    const CACHE_KEY = 'country_code_cache';
    const CACHE_EXPIRY = 600000;
    
    const DOMAIN_LIST = [
        'au.essenther.com', 'us.essenther.com', 'shop.essenther.com',
        'us.inlyric.com', 'shop.inlyric.com',
        'au.crzyoga.com', 'ca.crzyoga.com', 'de.crzyoga.com','mx.crzyoga.com','uk.crzyoga.com', 'us.crzyoga.com', 'shop.crzyoga.com', 
        'hk.crzyoga.com', 'sg.crzyoga.com', 'ph.crzyoga.com', 'my.crzyoga.com', 'jp.crzyoga.com', 'kr.crzyoga.com', 'th.crzyoga.com', 'in.crzyoga.com', 'vn.crzyoga.com', 'id.crzyoga.com', 'tw.crzyoga.com', 'co.crzyoga.com', 'mo.crzyoga.com', 'pe.crzyoga.com',
        'ae.crzyoga.com', 'sa.crzyoga.com', 'qa.crzyoga.com',
        'au.momanda.cc', 'ca.momanda.cc', 'eu.momanda.cc', 'uk.momanda.cc', 'us.momanda.cc', 'shop.momanda.cc',
        'us.solbrace.com', 'shop.solbrace.com'
    ];
    
    const EU_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
    
    function getCachedCountryCode() {
        try {
            const cache = localStorage.getItem(CACHE_KEY);
            if (!cache) return null;
            
            const { countryCode, timestamp } = JSON.parse(cache);
            if (Date.now() - timestamp > CACHE_EXPIRY) {
                localStorage.removeItem(CACHE_KEY);
                return null;
            }
            
            return countryCode;
        } catch (error) {
            return null;
        }
    }
    
    function cacheCountryCode(countryCode) {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({
                countryCode,
                timestamp: Date.now()
            }));
        } catch (error) {}
    }
    
    async function fetchCountryCode() {
        try {
            const response = await fetch(API_URL);
            if (!response.ok) return '';
            
            let countryCode = (await response.text()).toUpperCase();
            if (countryCode.length !== 2) return '';
            
            cacheCountryCode(countryCode);
            return countryCode;
        } catch (error) {
            return '';
        }
    }
    
    function processCountryCode(domain, code) {
        if (domain === 'inlyric.com' && ['AU', 'NZ'].includes(code)) return 'AUS';
        if (domain === 'momanda.cc' && EU_COUNTRIES.includes(code)) return 'EU';
        if (['GB', 'IE'].includes(code)) return 'UK';
        if (['AU', 'NZ'].includes(code)) return 'AU';
        return code;
    }
    
    async function executeRedirect() {
        const hostname = window.location.hostname.toLowerCase();
        const parts = hostname.split('.');
        let effectiveParts = parts;
        
        // 剔除 www. 前缀
        if (parts[0] === 'www') {
            effectiveParts = parts.slice(1);
        }

		// 有二级域名 → 直接返回，不执行跳转
        const hasValidSubdomain = effectiveParts.length > 2;
        if (hasValidSubdomain) return false;

        // 无二级域名 → 执行原跳转逻辑
        let countryCode = getCachedCountryCode() || await fetchCountryCode();
        if (countryCode.length !== 2) return false;
        
        const domain1 = effectiveParts.slice(-2).join('.');
        const processedCode = processCountryCode(domain1, countryCode);
        let targetDomain = processedCode.toLowerCase() + '.' + domain1;
        
        if (!DOMAIN_LIST.includes(targetDomain)) {
            targetDomain = 'shop.' + domain1;
        }

		const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        const fullPath = currentPath + currentSearch;

        // 避免跳转到自身（根域名→目标域名）
        if (targetDomain !== hostname && DOMAIN_LIST.includes(targetDomain)) {
            window.location.href = '//' + targetDomain + fullPath;
        }
    }
    
    if (!window._redirectExecuting) {
        window._redirectExecuting = true;
        executeRedirect().catch(() => {}).finally(() => {
            window._redirectExecuting = false;
        });
    }
})();